import { AUTH_ROUTE_ID } from '@/integrations/tanstack-router/auth-route-id';

export const IMAGE_MANAGEMENT_ROUTES = {
  index: '/image-management',
  imageEditor: '/image-management/image-editor',
  galleryMaintenance: '/image-management/gallery-maintenance',
  annotator: '/image-management/annotator/$id',
} as const;

export const IMAGE_MANAGEMENT_ROUTE_IDS = {
  imageEditor: `/${AUTH_ROUTE_ID}${IMAGE_MANAGEMENT_ROUTES.imageEditor}`,
  galleryMaintenance: `/${AUTH_ROUTE_ID}${IMAGE_MANAGEMENT_ROUTES.galleryMaintenance}`,
} as const;
